import axios from '../Backend';

export const fetchCallUpdatedCrmData = async (_id) => {
    try {
        if (!_id) return console.log('fetchCallUpdatedCrmData :: some data is missed')

        axios.put('/fetchCallUpdatedCrmData', { _id });

    } catch (e) {
        console.log('fetchCallUpdatedCrmData :: Error')
        console.log(JSON.stringify(e))
    }
}

export const transferCall = async (callId, phone) => {
    try {
        if (!callId || !phone) return console.log('transferCall :: some data is missed')

        axios.put('/call/transferCall', { callId, phone });

    } catch (e) {
        console.log('transferCall :: Error')
        console.log(JSON.stringify(e))
    }
}

export const confCall = async (callId, phone) => {
    try {
        if (!callId || !phone) return console.log('confCall :: some data is missed')

        const res = await axios.put('/call/confCall', { callId, phone });
        return res.data

    } catch (e) {
        console.log('confCall :: Error')
        console.log(JSON.stringify(e))
        return
    }
}

export const isCallStillLive = async () => {
    try {
        const res = await axios.get('/call/checkActiveCalls');
        return res.data
    } catch (e) {
        console.log('isCallStillLive :: Error')
        if (e && e.response && e.response.data) {
            console.log(JSON.stringify(e.response.data))
        }
        else {
            console.log(JSON.stringify(e))
        }
        return {inConv:false}
    }
}

export const checkExtenstionsStatus = async()=>{
    try {
        const response = await axios.get('/call/check-active-calls-by-extension');
        return response.data;
    } catch (error) {
        console.log(error?.response?.data?.msg);
    }
}

export const putCallOnHoldOrTalk = async (callId)=>{
    try{
        await axios.patch('/call/hold',{callId})
    }catch(e){
        if(e.response?.data){
            console.log(e.response.data)
        }
    }
}

